import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { MensajeSiNo } from "../../mensajes";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
} from "../../../util/varios";
import axios from "axios";
import CatalogoPersona from "../../../catalogos/catalogoPersona";
import moment from "moment";
import { SuccessButton } from "../../../ui/buttons/Button";

export const ActualizarCamposComercio = (props) => {
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo] = useState();
  const [msg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo2] = useState();
  const [msg2] = useState();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [tecla, setTecla] = useState();
  const [operacionPer, setOperacionPer] = useState(0);
  const [comerAct, setComerAct] = useState();
  const [repreAct, setRepreAct] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cmbRif = useRef("");
  const txtRif = useRef();
  const txtEmailContri = useRef();
  const [habilitadoNC, setHabilitadoNC] = useState("disabled");
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }
  }, [props.operacion]);
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/industria/camposcomercio`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          if (response.data) {
            setActivate(false);
            props.onHideAceptaActuCampo(
              txtEmailContri.current.value === "" ? false : true
            );
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const datosRes = (cedula, tecla) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtNombreRespon.current.value = "";
          txtApellidoRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmailRespon.current.value = "";
          txtTlfRespon.current.value = "";
          txtCelRespon.current.value = "";
          txtFechaNac.current.value = "";
          cmbNacionalidad.current.value = "V";
          cmbSexo.current.value = "M";
          setHabilitadoNR(true);
          setActivate(false);
          if (response.data !== "") {
            setHabilitadoNR(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidoRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailRespon.current.value = response.data.correoe;
            txtTlfRespon.current.value = response.data.tlf1;
            txtCelRespon.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment.utc(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNR(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };
  const handleCloseSi = () => {
    setMostrar1(false);
  };
  const handleCloseNo = () => {
    setMostrar1(false);
  };
  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputRif") {
        txtEmailContri.current.focus();
      } else if (event.target.id === "inputEmailContri") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtCedula.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtCedula.current.focus();
          }
        }
      } else if (event.target.id === "inputNomResponsable") {
        txtApellidoRespon.current.focus();
      } else if (event.target.id === "inputApeResponsable") {
        txtDireccionRespon.current.focus();
      } else if (event.target.id === "inputDireResponsable") {
        txtEmailRespon.current.focus();
      } else if (event.target.id === "inputEmailResponsable") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de número de telefonico invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtCelRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputCelResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de número de telefonico invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputEmailContri") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtCedula.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtCedula.current.focus();
          }
        }
      } else if (event.target.id === "inputEmailResponsable") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de número de telefonico invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtCelRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputCelResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de número de telefonico invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };
  const validarRif = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setActivate(true);
        let endpoint = op.seniat + "/rif=" + cmbRif + txtRif.current.value;
        axios
          .get(endpoint)
          .then(function (response) {
            if (response.status == 200) {
              response.data.rif === "error de conexion al seniat"
                ? (setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: "Error interno de Conexión",
                    icono: "informacion",
                  }),
                  operacion !== 3
                    ? setHabilitadoNC("")
                    : setHabilitadoNC("disabled"))
                : ((txtRif.current.value = response.data.rif),
                  setHabilitadoNC("disabled"));
            }
          })
          .catch(function (err) {
            if (err) {
              setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: err.message,
                icono: "error",
              });

              operacion !== 3
                ? setHabilitadoNC("")
                : setHabilitadoNC("disabled");
              txtCedula.current.focus();
            }
          })
          .then(function () {
            setActivate(false);
          });
      } else {
        /*setTitulo('error');
                setMsg('Introduzca su número de rif.');
                setMostrar(true);*/
      }
    }
  };
  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value, event.which);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };
  const onChangeValidar = () => {
    var sigue = true;
    if (cmbRif.current.value === "0") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto:
          "Por Favor Indique el Tipo de Persona en el Registro de Información Fiscal (RIF)",
        icono: "informacion",
      });
      sigue = false;
      cmbRif.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto:
          "El Numero de Registro de Información Fiscal (RIF) no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La cedula no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (
      txtNombreRespon.current.value.trim() === "" &&
      operacionPer === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Los nombres no deben estar vacios",
        icono: "informacion",
      });
      sigue = false;
      txtNombreRespon.current.focus();
    } else if (
      txtApellidoRespon.current.value.trim() === "" &&
      operacionPer === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Los Apellidos no deben estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtApellidoRespon.current.focus();
    } else if (
      txtDireccionRespon.current.value.trim() === "" &&
      operacionPer === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La direccion del responsable no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionRespon.current.focus();
    } else if (txtFechaNac.current.value.trim() === "" && operacionPer === 1) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La fecha de nacimiento no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var come = [];
      var repre = [];
      come.push({
        actualizado: txtEmailContri.current.value === "" ? false : true,
        email: txtEmailContri.current.value,
        idcomercio: props.comercio ? props.comercio.idcomercio : "0",
        reprelegal: txtCedula.current.value,
        rif: cmbRif.current.value + txtRif.current.value,
      });
      repre.push({
        apellidos: txtApellidoRespon.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailRespon.current.value,
        direccion: txtDireccionRespon.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfRespon.current.value,
        tlf2: txtCelRespon.current.value,
      });
      setComerAct(come);
      setRepreAct(repre);
      procesarSolicitud(come, repre);
    }
  };
  const procesarSolicitud = (come, repre) => {
    event.preventDefault();
    setActivate(true);
    setContar2(0);
    let body = {
      operacionper: operacionPer,
      declaweb: declaWeb,
      fechasis: fechaSistema,
      come: JSON.stringify(come),
      repre: JSON.stringify(repre),
    };
    procesarRegistro(body);
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreRespon.current.value = nomPer;
    txtApellidoRespon.current.value = apePer;
    txtDireccionRespon.current.value = direPer;
    txtEmailRespon.current.value = correoPer;
    txtTlfRespon.current.value = tlf1Per;
    txtCelRespon.current.value = tlf2Per;
    txtFechaNac.current.value = fnacPer;
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setDeclaWeb(Boolean(props.declaweb));
      }}
    >
      <Modal.Body>
        <div className="amanecergris tipo-letra">
          <div className="container">
            <div className="row">
              <h2 className="mt-3 mb-4  text-center">
                Actualice los siguientes datos al Contribuyente
              </h2>

              <div className="input-group input-group-sm mb-2 col-md-4">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Nº de RIF:
                </span>
                <select
                  disabled={deshabilitado}
                  ref={cmbRif}
                  className="form-select form-select-sm col-md-3"
                  id="inputLetraRif"
                  defaultValue={
                    props.comercio && isNaN(props.comercio.rif.substring(0, 1))
                      ? props.comercio.rif.substring(0, 1)
                      : ""
                  }
                  onKeyUp={validarRif}
                  onBlur={validarRif}
                >
                  <option value="J">J</option>
                  <option value="V">V</option>
                  <option value="G">G</option>
                  <option value="E">E</option>
                  <option value="P">P</option>
                </select>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtRif}
                  maxLength={14}
                  className="form-control form-control-sm"
                  placeholder="123456789"
                  id="inputRif"
                  defaultValue={
                    props.comercio && isNaN(props.comercio.rif.substring(0, 1))
                      ? props.comercio.rif.substring(
                          1,
                          props.comercio.rif.trim().length
                        )
                      : props.comercio &&
                        !isNaN(props.comercio.rif.substring(0, 1))
                      ? props.comercio.rif.substring(
                          0,
                          props.comercio.rif.trim().length
                        )
                      : ""
                  } /*onKeyUp={validarRif} onBlur={validarRif}*/
                />
              </div>

              <div className="col-md-2"></div>

              <div className="input-group input-group-sm mb-2 col-md-6">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Correo Electrónico:
                </span>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtEmailContri}
                  className="form-control form-control-sm "
                  id="inputEmailContri"
                  defaultValue={
                    props.comercio
                      ? props.comercio.email !== null
                        ? props.comercio.email.trim()
                        : ""
                      : ""
                  }
                  onKeyUp={handleInputChange}
                />
              </div>

              <div className="row col-md-12 mx-auto">
                <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
                  <legend className="float-none w-auto">Responsable</legend>

                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula:
                    </span>
                    <select
                      name=""
                      disabled={!habilitadoNR}
                      ref={cmbNacionalidad}
                      defaultValue={
                        props.representante
                          ? props.representante.nacionalidad
                          : ""
                      }
                      /*onChange={handleChangeEstado}*/ className="form-control form-control-sm col-md-2 bg-light"
                    >
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="E">
                        E
                      </option>
                    </select>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      ref={txtCedula}
                      className="form-control form-control-sm bg-light"
                      id="inputCedula"
                      defaultValue={
                        props.representante ? props.representante.cedula : ""
                      }
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={deshabilitado}
                      onClick={catalogoPer}
                      className="btn btn-sm btn-info"
                    >
                      <i disabled={deshabilitado} className="fas fa-search"></i>{" "}
                    </button>
                  </div>

                  <div className="col-md-4"></div>

                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha de Nacimiento:
                    </span>
                    <input
                      type="date"
                      disabled={!habilitadoNR}
                      ref={txtFechaNac}
                      className="form-control form-control-sm"
                      id="inputFechaNac"
                      max={fechaSistema}
                      defaultValue={
                        props.representante
                          ? moment.utc(props.representante.fnacimiento).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-6">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombres:
                    </span>
                    <input
                      type="text"
                      disabled={!habilitadoNR}
                      ref={txtNombreRespon}
                      className="form-control form-control-sm bg-light"
                      id="inputNomResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.nombres.trim()
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-6">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Apellidos:
                    </span>
                    <input
                      type="text"
                      disabled={!habilitadoNR}
                      ref={txtApellidoRespon}
                      className="form-control form-control-sm bg-light"
                      id="inputApeResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.apellidos.trim()
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-5">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Correo Electronico:
                    </span>
                    <input
                      type="text"
                      disabled={!habilitadoNR}
                      ref={txtEmailRespon}
                      className="form-control form-control-sm bg-light"
                      id="inputEmailResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.correoe !== null
                            ? props.representante.correoe.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Telefono:
                    </span>
                    <input
                      type="text"
                      disabled={!habilitadoNR}
                      ref={txtTlfRespon}
                      className="form-control form-control-sm bg-light"
                      id="inputTlfResponsable"
                      placeholder="0000-0000000"
                      defaultValue={
                        props.representante
                          ? props.representante.tlf1 !== null
                            ? props.representante.tlf1.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-3">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sexo:
                    </span>
                    <select
                      name=""
                      disabled={!habilitadoNR}
                      ref={cmbSexo}
                      defaultValue={
                        props.representante ? props.representante.sexo : ""
                      }
                      /*onChange={handleChangeMunicipio}*/ className="form-control form-control-sm bg-light"
                    >
                      <option key="0" value="M">
                        M
                      </option>
                      <option key="1" value="F">
                        F
                      </option>
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-8">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </span>
                    <input
                      type="text"
                      disabled={!habilitadoNR}
                      ref={txtDireccionRespon}
                      className="form-control form-control-sm bg-light"
                      id="inputDireResponsable"
                      defaultValue={
                        props.representante
                          ? props.representante.direccion.trim()
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Celular:
                    </span>
                    <input
                      type="text"
                      disabled={!habilitadoNR}
                      ref={txtCelRespon}
                      className="form-control form-control-sm bg-light"
                      id="inputCelResponsable"
                      placeholder="0000-0000000"
                      defaultValue={
                        props.representante
                          ? props.representante.tlf2 !== null
                            ? props.representante.tlf2.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        titulo={titulo2}
        mensaje={msg2}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
